module.exports = __webpack_public_path__ + "static/media/graphOff_118.dedaa951.png";